import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'defaultOrderKeyValue'
})
export class DefaultOrderKeyValuePipe implements PipeTransform {

  transform(value: any,): unknown {
    return Object.keys(value);
  }

}
